export default {
    searchList: {
        searchTxt: [],
    },
    table: {
        // tableCut: true,
        showTooltip: true,
        // clickModify: true,
        selectBtn: false,
        leftOperation: true,
        height: 'calc(100vh - 344px)',
        columns: [
            {
                label: '供应商名称',
                prop: 'supplierNameCn',
                width: '200px',
                sort: true,
            },
            {
                label: '承运商类别',
                prop: 'transTypeText',
                width: '150px',
                sort: true,
            },
            {
                label: '注册省份',
                prop: 'provinceName',
                width: '120px',
                sort: true,
            },
            {
                label: '注册城市',
                prop: 'cityName',
                width: '120px',
                sort: true,
            },
            {
                label: '优势区域',
                prop: 'advantageProvinceName',
                width: '120px',
                sort: true,
            },
            {
                label: '优势车型',
                prop: 'advantageLengthName',
                width: '120px',
                sort: true,
            },
            {
                label: '优势行业',
                prop: 'advantageIndustryName',
                width: '120px',
                sort: true,
            },
            {
                label: '自有车数量',
                prop: 'ownerCarNum',
                width: '120px',
                sort: true,
            },
            {
                label: '联系人',
                prop: 'name',
                width: '150px',
                sort: true,
            },
            {
                label: '联系人手机号',
                prop: 'mobile',
                width: '140px',
                sort: true,
            },
            {
                label: '供应商与安得合作年限',
                prop: 'cooperationPeriod',
                width: '180px',
                sort: true,
            },
            {
                label: '通知次数',
                width: '100px',
                prop: 'noticeNum',
            },
            {
                label: '类型',
                width: '100px',
                prop: 'matchType',
                type: 'select',
                optionNum: 'BID_LINE_DIVISION_MATCH_TYPE',
            },
            {
                label: '是否有意向',
                width: '100px',
                type: 'select',
                optionNum: 'SRM_YES_NO',
                prop: 'isIntention',
            },
            {
                label: '意向线路',
                width: '100px',
                type: 'input',
                prop: 'intentionLine',
            },
            {
                label: '无意向原因',
                width: '100px',
                type: 'input',
                prop: 'noIntentionReason',
            },
        ],
        action: [
            {
                type: 'text',
                label: '编辑',
                size: 'small',
                event: 'edit',
            },
            {
                type: 'text',
                label: '供应商评级',
                size: 'small',
                event: 'rank',
            },
        ],
        leftWidth: 140,
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
    },
}
